import React, { useEffect, useRef } from 'react'
import { Modal, Spinner, Button, OverlayTrigger, Tooltip } from '@themesberg/react-bootstrap'
import { categoryTypeEnums } from "../constant"
import { ca } from 'date-fns/locale'


const FALLBACK_THUMBNAIL = 'https://via.placeholder.com/150x100?text=No+Preview'


function CasinoGamesModal({
  title = 'Casino Games',
  show = false,
  games = [],
  hasMore = false,
  onFetchMore = () => { },
  onClose = () => { },
  loading = false,
  onHandleDeleteCategoryGame,
  isDeleteCategorygames,
  category
}) {
  const observerTarget = useRef(null)
  const scrollContainerRef = useRef(null)

  useEffect(() => {
    if (!show) return

    const sentinelElement = observerTarget.current
    const rootElement = scrollContainerRef.current

    if (!sentinelElement || !rootElement) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onFetchMore()
        }
      },
      {
        root: rootElement,
        rootMargin: '100px',
        threshold: 0.1,
      }
    )

    observer.observe(sentinelElement)

    return () => {
      observer.disconnect()
    }
  }, [show, hasMore, games.length, loading, onFetchMore])

  const renderGameCard = (game) => {
    const thumbnail =
      game?.videoSnapshot?.thumbnails?.M ||
      game?.videoSnapshot?.thumbnails?.S ||
      FALLBACK_THUMBNAIL
    const isVault = categoryTypeEnums.vault === category?.categoryType
    return (
      <div className="card h-100">
        <img
          src={thumbnail}
          alt={game?.name}
          className="card-img-top"
          style={{ height: '150px', objectFit: 'cover' }}
        />
        <div className="card-body d-flex justify-content-between flex-column">
          <h6 className="card-title mb-1 fw-bold">{game?.name || 'Unnamed game'}</h6>
          {!isDeleteCategorygames && !isVault && <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>
                Deleting this game will remove it from this category only
              </Tooltip>
            }
          >
            <Button variant="danger" size="sm" onClick={() => onHandleDeleteCategoryGame(game)}>Delete</Button>
          </OverlayTrigger>}
        </div>

      </div>
    )
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      backdrop="static"
      style={{ backdropFilter: 'blur(15px)', WebkitBackdropFilter: 'blur(15px)' }}
      className="py-2"
    >
      <Modal.Header closeButton className="border-1 pb-2">
        <h4 className="fw-bold text-dark mb-0" style={{ fontSize: '1.4rem' }}>
          {title}
        </h4>
      </Modal.Header>
      <div
        id="casino-games-modal-list"
        ref={scrollContainerRef}
        style={{ maxHeight: '60vh', overflow: 'auto' }}
      >
        <Modal.Body className="pb-0">
          {loading && !games.length ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" role="status" size="lg" />
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row g-3 mb-3 mt-1">
                {games.length > 0 ? (
                  <>
                    {games.map((game) => (
                      <div key={game?.casinoGameId} className="col-12 col-sm-6 col-md-4 col-lg-3">
                        {renderGameCard(game)}
                      </div>
                    ))}
                    {hasMore && (
                      <div
                        ref={observerTarget}
                        className="col-12 d-flex justify-content-center py-3"
                        style={{ minHeight: '50px' }}
                      >
                        {loading && <Spinner animation="border" role="status" size="sm" />}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="col-12">
                    <div className="text-center text-muted py-4">No games available.</div>
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
      </div>
    </Modal>
  )
}

export default CasinoGamesModal